import React, { Component } from 'react';
import ProductDefaultImage from '../../../assets/images/product-default-image.jpg'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { connect } from 'react-redux';
// src/containers/commons/Hello.js
class ProductCard extends Component {
  render() {
    const { data, onSelectProduct, onAddToCart, noOutOfStock, label } = this.props;

    const productTitle = data && data.Description ? data.Description : '';
  const productImage = data && data.image ? data.image : null;
  const urlImage = productImage ? productImage.replace(/upload/, 'upload/w_250,h_280,c_fill')
    : null;
  const basePrice = data && data.PriceB !== undefined && data.PriceB !== null
    ? data.PriceB
    : data && data.Price !== undefined && data.Price !== null
      ? data.Price
      : null;
  const numericPrice = basePrice !== null && basePrice !== '' ? Number(basePrice) : NaN;
  const productPrice = Number.isNaN(numericPrice) ? '' : numericPrice.toFixed(2);
  // console.log("productPrice",data);
  const productSize = data && data.Size ? data.Size : '';
  const isOutOfStock = data && typeof data.isOutOfStock === 'boolean'
    ? data.isOutOfStock
    : data && typeof data.stockStatus === 'string'
      ? data.stockStatus.toLowerCase() === 'out of stock'
      : !(data && data.Qty > 0);
  const isOnSale = data.OnSale ? true : false
  const salePrice = data.SalePrice;
  return (
    <div className="product-card">
      {label ? <div className="product-card__badge">{label}</div> : null}
      <div className="image-container" onClick={onSelectProduct ? onSelectProduct : null}>
        <div className="wrapper">
          <LazyLoadImage alt={productTitle} scrollPosition={50} src={urlImage ? urlImage : ProductDefaultImage} onError={(e) => {
            return e.target.src = ProductDefaultImage
          }}/>
        </div>
      </div>
      <div className={`info-container ${onAddToCart ? 'has-cart-button' : ''}`}>
        <div className="title" onClick={onSelectProduct ? onSelectProduct : null}>{productTitle}</div>
        <div className="subtitle">{productSize}</div>
        {isOnSale ? (
          <div className="sale-price-container">
            <div className="price-stack">
              <span className="sale-label">WAS</span>
              <div className="sale-original-price-text" onClick={onSelectProduct ? onSelectProduct : null}>
                <s>{productPrice ? `$${productPrice}` : ''}</s>
              </div>
            </div>
            <div className="price-stack">
              <span className="sale-label">NOW</span>
              <div className="sale-price-text" onClick={onSelectProduct ? onSelectProduct : null}>
                {salePrice ? `$${salePrice}` : ''}
              </div>
            </div>
          </div>
        ) : (
          <div className="price-text" onClick={onSelectProduct ? onSelectProduct : null}>
            {productPrice ? `$${productPrice}` : ''}
          </div>
        )}
        {onAddToCart ? (
          <button className="add-to-cart-button" onClick={onAddToCart}>Add to Cart</button>
        ) : null}

      </div>
      {isOutOfStock && !noOutOfStock ? (
        <div className="outofstock-tag">Out of Stock</div>
      ) : null}
    </div>
  )
  }
}

export default connect((state) => {
  return {
    cart: state.getIn(['cart', 'cart']),
  };
})(ProductCard);



// WEBPACK FOOTER //
// ./src/components/commons/cards/ProductCard.js